import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Colors, Sizes } from '../../../shared/enums/shared.enums';

import { IconComponent } from '../../atoms/icon/icon.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'hdi-expand',
  standalone: true,
  imports: [CommonModule, IconComponent, ModalComponent],
  templateUrl: './expand.component.html',
  styleUrl: './expand.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class ExpandComponent {
  @Input() size: Sizes = Sizes.XSMALL;
  @Input() disabled: boolean = false;
  @Input() color: Colors = Colors.BLACK;
  @Input() label: string = '';
  showModal: boolean = false;

  get sizeIcon(): Sizes {
    return this.size;
  }

  get colorIcon(): Colors {
    return this.color;
  }

  get expandIconType(): string {
    return 'expand';
  }

  get disabledState(): boolean {
    return this.disabled;
  }

  openModal(): void {
    this.showModal = true;
  }
}
